import dayjs from "dayjs";
import * as Bowser from "bowser";
export const browser = Bowser.getParser(window.navigator.userAgent);

const queryString = require('query-string');
export function getQuery(){
    return queryString.parse(window.location.search);
}

/**
 * 后端 post.status 中「在 Web 端必须整体隐藏」的状态：
 * -3 审核不通过 / -1 被举报下架 / 3 待人工审核隐藏（作者也不可见）。
 * Web 详情页带分享二维码和可复制链接，这些内容一旦可达就可能继续向微信扩散，
 * 所以列表与详情统一用本判断隐藏；待审核 0 与自见 2 不在隐藏范围。
 * （status=3 后端详情接口本身会 404，这里是展示层防御口径）
 * @param status post.status
 * @returns {boolean}
 */
export function isHiddenPostStatus(status){
    return status===-1||status===-3||status===3
}

/**
 * 驼峰转下划线
 * @param str
 * @returns {string}
 */
export function underline(str){
    return str.replace(/\B([A-Z])/g, '_$1').toLowerCase()
}

/**
 * 格式化时间为：1天前，几小时前
 * @param time
 * @returns {string}
 */
export function formatDate(time){
    let dateTime=dayjs(time).format('YYYY-MM-DD HH:mm')
    if(Date.now()-new Date(time)<3600*1000*6){
        dateTime=dayjs(time).fromNow()
    }
    return dateTime
}

/**
 * 显示简化时间，今年的时间不显示年份
 * @param time
 */
export function simpleDate(time) {
    // 获取当前时间
    const now = dayjs(time);
    // 获取年份
    const year = now.year();
    // 获取月份和日期
    let monthDate = now.format("M月D日");
    // 如果是今年之前的时间，添加年份
    if (now.isBefore(dayjs(`${year}-01-01`))) {
        monthDate = `${year}年${monthDate}`;
    }
    // 获取小时和分钟
    const hourMinute = now.format("HH:mm");
    return `${monthDate} ${hourMinute}`;
}


export function isWechat() {
    return browser.getBrowserName() === "WeChat";
}

export function extractFirstUrl(text) {
    const regex = /((?:https?|ftp):\/\/[\w-]+(?:\.[\w-]+)+(?:[\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?)/;
    const match = regex.exec(text);

    if (match) {
        return match[0];
    } else {
        return '';
    }
}


